import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnInit, Output, SimpleChanges, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { SettlementsService } from 'src/app/services/settlements.service';
import { IconsService } from 'src/app/shared/services/icons.service';
import { ngxCsv } from 'ngx-csv/ngx-csv';
import { DateService } from 'src/app/shared/services/date.service';

@Component({
  selector: 'app-modal-settlement-statement',
  template: `
  <ng-template #modalSettlementStatement let-modal>
    <div class="modal-header"></div>
    <div class="modal-body p-4">
      <!-- form [formGroup]="formStatement">
        <div class="form-group mt-4">
          <label for="created_at_since" class="form-label text-sm">Fecha inicial</label>
          <input type="date" class="form-control " formControlName="created_at_since" placeholder="Fecha inicial" bsDatepicker>
        </div>
        <div class="form-group mt-4">
          <label for="created_at_to" class="form-label text-sm">Fecha final</label>
          <input type="date" class="form-control" formControlName="created_at_to" placeholder="Fecha final" bsDatepicker>
        </div>
        <div class="form-group text-end mt-5">
          <button type="button" class="btn btn-primary" (click)="generateReport()">Generar reporte</button>
        </div>
      </!-->
    </div>
  </ng-template>
  `,
  styleUrls: []
})
export class ModalSettlementStatementComponent {
  @Input() settlement : any;
  @Output() updateDismiss: EventEmitter<any> = new EventEmitter<any>();
  @ViewChild('modalSettlementStatement') modalSettlementStatement !: ElementRef;

  private modalRef: NgbModalRef | undefined;
  formStatement: FormGroup = new FormGroup({});

  constructor(
      private store: SettlementsService,
      private toastr: ToastrService,
      private fb: FormBuilder,
      private modalService: NgbModal,
      public icons: IconsService,
      public dateService: DateService
  ) {}

  ngOnInit(): void {
    this.initForm();
  }

  initForm() {
    this.formStatement = this.fb.group({
      created_at_since: ['', Validators.required],
      created_at_to: ['', Validators.required]
    });
  }

  openModal(modalContent: TemplateRef<any>) {
    this.modalRef = this.modalService.open(modalContent);
  }

  dismiss() {
    if (this.modalRef) {
      this.updateDismiss.emit();
      this.modalRef.dismiss();
    }
  }

  generateReport() {
    this.store.getBillsBySettlement(this.settlement.settlement.id, {
      created_at_since: this.formStatement.value.created_at_since,
      created_at_to: this.formStatement.value.created_at_to,
      state: [1,2],
      page: 1,
      per_page: 10000
    }).subscribe((response: any) => {
        console.log('getBillsBySettlement response => ', response);
        let bills: any[] = [];
        response.data.map((bill: any) => {
            bills.push({
              id: bill.id,
              reference: bill?.reference ? bill?.reference : '-',
              description: bill?.description ? bill?.description : '-',
              settlement_name: bill?.settlement_name,
              building_name: bill?.building_name,
              floor_name: bill?.floor_name,
              unit_name: bill?.unit_name,
              status: bill?.status ? 'Pagado' : 'Pendiente',
              consumo_m3: bill?.consumo_m3 ? bill?.consumo_m3.toFixed(2) : '-',
              consumo_lt: bill?.meter_consumption ? (bill?.meter_consumption).toFixed(2) : '-',
              consumo_periodo: bill?.consumption_total ? bill?.consumption_total.toFixed(2) : '-',
              sub_total: bill?.sub_total ? `$ ${bill?.sub_total.toFixed(2)}` : '-',
              total: `$ ${bill?.total.toFixed(2)}`,
              days: bill?.days || '-',
              read_prev: bill?.meter_previous_read,
              read_curr: bill?.meter_current_read,
              discount: bill?.discount || '-',
              periodo_inicio: bill?.periodo_inicio ? this.dateService.formatYMD(bill?.periodo_inicio) : 'No disponible',
              periodo_fin: bill?.periodo_fin ? this.dateService.formatYMD(bill?.periodo_fin) : 'No disponible',
              due_date: bill?.due_date ? this.dateService.formatYMD(bill?.due_date) : 'No disponible',
              paid_date: bill?.paid_date ? this.dateService.formatYMD(bill?.paid_date) : 'No pagado',
              created_at: bill?.created_at ? this.dateService.formatYMD(bill?.created_at) : 'No disponible',
              updated_at: bill?.updated_at ? this.dateService.formatYMD(bill?.updated_at) : 'No disponible',
              admin_price: `$ ${bill?.admin_fee_total || 0}`,
              interests: `$ ${bill?.late_fee_total || 0}`,
              taxes: `$ ${bill?.taxes || 0}`,
              recargos: `$ ${bill?.service_total || 0}`,
              consumo_total: bill?.consumption_total,
              state: bill?.state == 1 ? 'Pendiente' : bill?.state == 2 ? 'Pagado' : 'Cancelado',
              invoiced: bill?.invoiced ? 'Sí' : 'No',
              invoice_id: bill?.invoice_id ? bill?.invoice_id : '-',
              gas_price: bill?.gas_price || '-',
              meter_read_date: bill?.meter_read_date ? this.dateService.formatYMD(bill?.meter_read_date) : 'No disponible'
            });
        });

        let options = {
          title: `Reporte de condominio ${this.settlement?.name}`,
          fieldSeparator: ',',
          quoteStrings: '"',
          decimalSeparator: '.',
          showLabels: true,
          noDownload: false,
          showTitle: true,
          useBom: true,
          headers: [
            "# Recibo",
            "Referencia",
            "Descripción",
            "Condominio",
            "Edificio",
            "Piso",
            "Departamento",
            "Estatus",
            "Consumo M3",
            "Consumo LT",
            "Consumo Periodo",
            "Sub total",
            "Total",
            "Días",
            "Lectura prev.",
            "Lectura actual",
            "Descuento",
            "Periodo inicio",
            "Periodo fin",
            "Vencimiento",
            "Fecha pago",
            "Creado",
            "Actualizado",
            "Admin.",
            "Moratorios",
            "IVA",
            "Recargos",
            "Consumo total",
            "Estado",
            "Facturado",
            "# Factura",
            "Precio gas",
            "Fecha lectura medidor"
          ]
        };

        new ngxCsv(bills, 'Reporte Condominio', options);
      });
  }
}
